// A note, cut down to what a row can carry.
//
// A note is INTERNAL CONTEXT — why a clause counts what it counts, what a
// reader should know before they change it. Printed in full under the thing it
// annotates it stops being context and becomes the loudest text on the row:
// "Uncached prompt tokens at the input rate. input_tokens on a fact is the
// normalized total, so this counts uncached_input_tokens." is three lines of
// prose under a two-word charge.
//
// So a row carries a hint of the note and the screen keeps the whole of it
// somewhere else — on the hover, in the disclosure, in the form that owns it.
// The cut is marked, because a cut with no mark reads as the whole note.

/** How much of a note a row carries, in characters. */
export const NOTE_SUMMARY_LIMIT = 80;

/** The mark that says the note goes on. */
const MORE = " …";

/**
 * The first line of a note, cut at a word to `NOTE_SUMMARY_LIMIT`.
 *
 * The cut lands on a word boundary, never inside a word: half of
 * `uncached_input_tokens` is a different identifier, and a reader checking a
 * clause against a rate card would look for it.
 */
export function noteSummary(note: string): string {
  const [firstLine = ""] = note.split("\n");
  const head = firstLine.trim();
  const rest = note.slice(firstLine.length).trim();

  if (head.length <= NOTE_SUMMARY_LIMIT) {
    return rest === "" ? head : `${head}${MORE}`;
  }

  const cut = head.slice(0, NOTE_SUMMARY_LIMIT);
  const lastSpace = cut.lastIndexOf(" ");
  // A "word" longer than the whole budget is one token — a URL, an identifier —
  // so it is cut where the budget ends rather than dropped altogether.
  const kept = lastSpace <= 0 ? cut : cut.slice(0, lastSpace);
  return `${kept.trimEnd()}${MORE}`;
}
